import React, { Fragment, Suspense } from "react";
import { Helmet } from "react-helmet";
import { metaTag } from "../Library/commomLib";
import Preloader from "../Components/Common/Preloader";
const TransactionDetailsComponent = React.lazy(
  () => import("../Components/RootComponents/TransactionDetailsComponent")
);
const TransactionDetailsPage = () => {
  return (
    <Fragment>
      <Suspense fallback={<Preloader />}>
        <Helmet>
          <title>{metaTag}</title>
          <meta name={metaTag} content={metaTag} />
        </Helmet>
        <TransactionDetailsComponent />
      </Suspense>
    </Fragment>
  );
};

export default TransactionDetailsPage;
